import React, { Component } from "react";
import Reaptcha from "reaptcha";
import PropTypes from 'prop-types';
import {getEmailFromStorage} from '../../utils/helpers/storageUtils';


class RegisterModal extends Component {
  render() {
    const {
      modalId = "registerModal",
      logoSrc = "images/modal-logo.svg",
      closeButtonElement = null,
      email = "",
      code = "",
      codeError = "",
      codeStatus = false,
      disableVerifyOkButton = false,
      handleInputChange,
      onKeyPressData,
      onlyAcceptInputs,
      displayResendSMSForEmail,
      displayChangeEmail,
      showMobileandEmailAddress = false,
      stylingOfNextButtonPopup,
      handleRecaptchaEmailVerify,
      resendSuccessMessagDisplay,
      resendErrorMessageDisplay,
      reCaptchaProps = {}
    } = this.props;

    return (
      <dialog className="modal fade" id={modalId} tabIndex="-1" aria-labelledby={`${modalId}Label`} aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog">
          <div className="modal-content">
            {closeButtonElement}
            <div className="modal-body pt-0 pb-0">
              <div className="logo">
                <img src={logoSrc} alt="logo" className="img-fluid" />
              </div>
              <p className="sub-context">Enter the 5-digit code we have sent to {email || getEmailFromStorage()}</p>
              <input className="form-control" type="text" id="code" name="code" placeholder="Enter code here" value={code} onKeyPress={(event) => onKeyPressData(event)} onPaste={(e) => onlyAcceptInputs(e)} required onChange={(e) => handleInputChange(e)} />
              <p className="text-center modal-error-msg mt-3">
                {codeError !== "" && <span style={{ color: "#e60000", fontSize: "0.8rem" }}>{codeError}</span>}
              </p>
              <p className="text-center link--block mb-0">
                {displayResendSMSForEmail()}
                {showMobileandEmailAddress && displayChangeEmail()}
              </p>
            </div>
            {codeStatus && (
              <p id="verificationMessage" className="modal-error-msg text-center">
                {resendSuccessMessagDisplay()}
                {resendErrorMessageDisplay()}
              </p>
            )}
            {reCaptchaProps.render && (
              <Reaptcha size="invisible" ref={reCaptchaProps.refCallback} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onLoad={reCaptchaProps.onLoad} onVerify={reCaptchaProps.onVerify} />
            )}
            <div className="modal-footer pb-0 pl-0">
              <button type="button" id="register-redirect-screen" className={stylingOfNextButtonPopup()} disabled={disableVerifyOkButton} onClick={(e) => handleRecaptchaEmailVerify(e)}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </dialog>
    );
  }
}
RegisterModal.propTypes = {
  modalId: PropTypes.string,
  logoSrc: PropTypes.string,
  closeButtonElement: PropTypes.any,
  email: PropTypes.string,
  code: PropTypes.any,
  codeError: PropTypes.string,
  codeStatus: PropTypes.bool,
  disableVerifyOkButton: PropTypes.bool,
  handleInputChange: PropTypes.func,
  onKeyPressData: PropTypes.func,
  onlyAcceptInputs: PropTypes.func,
  displayResendSMSForEmail: PropTypes.func,
  displayChangeEmail: PropTypes.func,
  showMobileandEmailAddress: PropTypes.bool,
  stylingOfNextButtonPopup: PropTypes.func,
  handleRecaptchaEmailVerify: PropTypes.func,
  resendSuccessMessagDisplay: PropTypes.func,
  resendErrorMessageDisplay: PropTypes.func,
  reCaptchaProps: PropTypes.any,
}
export default RegisterModal;
